/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";

import { Row, Col, Checkbox, Modal, Button, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { translate } from 'react-i18next'

import {
  GET_MY_RECORDS_USAGE,
  GET_CLOUD_RECORDS,
  DELETE_CLOUD_RECORDS,
} from "../../redux/actions/type";
import MyRecordProgress from "../UserProfile/MyRecordProgress"
import { IconHelper } from '../../helpers'

import RecordItem from "./RecordItem"
import StorageWarningBanner from "./StorageWarningBanner"
import OrderSelection from "./OrderSelection"
import DatePickerSelection from "./DatePickerSelection"
import UpsellPackage from './UpsellPackage'

const RecordDetail = ({ t, keycloak, pagination, language }) => {
  const { IconDeleteLight } = IconHelper
  const dispatch = useDispatch();
  
  const [orderBy, setOrderBy] = useState("create_date:desc");
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [recordsChecked, setRecordsChecked] = useState({});
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isItemChecked, setIsItemChecked] = useState(false);
  const [isCanRecord, setIsCanRecord] = useState(false)
  const [checkAllStatus, setCheckAllStatus] = useState(false);
  const [showPopupConfirmDelete, setShowPopupConfirmDelete] = useState(false);
  const [deleteList, setDeleteList] = useState([]);
  const [popupDeleteType, setPopupDeleteType] = useState('confirm')

  const cloudRecords = useSelector((state) => state.cloudRecords);
  const userProfileHistory = useSelector(state => state.userProfileHistory)

  const recordsList = cloudRecords.cloud_records;
  const deleteStatus = cloudRecords.delete_status;
  const currentPackage = userProfileHistory.currentPackage

  const numAndTextSpace = language === 'cn' ? '' : ' '

  const fetchRecords = () => {
    setIsAllChecked(false);
    const params = {
      page: pagination.page,
      perPage: pagination.perPage,
      sortBy: orderBy,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    };
    // console.log("params", params);
    dispatch({
      type: GET_CLOUD_RECORDS,
      ...params,
    });
  };

  const fetchAll = () => {
    dispatch({
      type: GET_MY_RECORDS_USAGE,
    });
    fetchRecords();
  };

  const setChecked = (id, value) => {
    setRecordsChecked({
      ...recordsChecked,
      [id]: value,
    });
  };

  const deleteCheckedItem = async () => {
    dispatch({
      type: DELETE_CLOUD_RECORDS,
      recordDelete: deleteList,
    });
  };

  const handleCheckedAll = (checked) => {
    setIsAllChecked(!checked);
    setTimeout(() => {
      setIsAllChecked(checked);
    }, 10);
  };

  const handleDeleteRecord = (recordId = null) => {
    setPopupDeleteType('confirm')
    const recordDelete = [];
    if (recordId) {
      recordDelete.push(recordId);
    } else {
      for (const [key, value] of Object.entries(recordsChecked)) {
        if (value) {
          recordDelete.push(key);
        }
      }
    }
    setDeleteList(recordDelete);
    setShowPopupConfirmDelete(true);
  };

  useEffect(() => {
    if (pagination.page && pagination.perPage) {
      fetchRecords();
    }
    return () => {};
  }, [pagination, orderBy, dateRange]);

  useEffect(() => {
    const data = {};
    recordsList.forEach((record) => {
      data[record.record_id] = false;
    });
    setRecordsChecked(data);

    if(recordsList.length === 0 && pagination.page !== 1) {

    }

    return () => {};
  }, [recordsList]);

  useEffect(() => {
    const data = {};
    if (isAllChecked) {
      for (const [key] of Object.entries(recordsChecked)) {
        data[key] = true;
      }
      setCheckAllStatus(true);
    } else {
      for (const [key] of Object.entries(recordsChecked)) {
        data[key] = false;
      }
      setCheckAllStatus(false);
    }
    setRecordsChecked(data);
    return () => {};
  }, [isAllChecked]);

  useEffect(() => {
    let isChecked = false;
    // eslint-disable-next-line no-unused-vars
    for (const [_key, value] of Object.entries(recordsChecked)) {
      if (value) {
        isChecked = true;
      }
    }
    setIsItemChecked(isChecked);

    const isAllTrue =
      Object.keys(recordsChecked).length !== 0
        ? Object.values(recordsChecked).every((item) => item === true)
        : false;
    setCheckAllStatus(isAllTrue);

    return () => {};
  }, [recordsChecked]);

  useEffect(() => {
    if(currentPackage.feature?.length > 0) {
      if(currentPackage.feature.indexOf('recording') !== -1) {
        setIsCanRecord(true)
      } else {
        setIsCanRecord(false)
      }
    }
    return () => {}
  }, [currentPackage])

  useEffect(() => {
    if(deleteStatus === 'success') {
      fetchAll();
      setShowPopupConfirmDelete(false)
      notification.open({
        message: deleteList.length > 1 ? `${t('my_record.delete_noti2', { fileNum: deleteList.length })}` : `${t('my_record.delete_noti', { fileNum: deleteList.length })}`,
        placement: 'bottomRight',
        className: 'landing-notification',
        icon: <IconDeleteLight />,
        duration: 5,
        closeIcon: <div></div>
      })
    }

    if(deleteStatus === 'error') {
      setPopupDeleteType('delete')
    }
    return () => {}
  }, [deleteStatus])

  return (
    <>
      <Row type="flex">
        <Col span={24}>
          <MyRecordProgress />
          <StorageWarningBanner />
        </Col>
      </Row>
      {!isCanRecord ? <Row type="flex">
        <Col span={24}>
          <UpsellPackage isHaveRecords={recordsList.length > 0} />
        </Col>
      </Row> : null}
      <Row type="flex" gutter={10} className="record-filter">
        <Col span={15}>
          <OrderSelection onSelected={setOrderBy} />
        </Col>
        <Col span={9}>
          <DatePickerSelection onSelected={setDateRange} language={language} />
        </Col>
      </Row>
      <Row type="flex" className="sectionPad">
        <Col span={18}>
          <Checkbox
            checked={checkAllStatus}
            onChange={(e) => handleCheckedAll(e.target.checked)}
            className="vroom-checkbox"
          >
            {t('my_record.select_all')}
          </Checkbox>
        </Col>
        <Col span={6} className="right">
          {isItemChecked ? (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a onClick={() => handleDeleteRecord()} className="delete-records">
              {t('my_record.delete')}
            </a>
          ) : null}
        </Col>
      </Row>
      <div className="hr" />
      <div>
        {recordsList.length === 0 ? <div className="no-record">{t('my_record.no_record')}</div> : null}
        {recordsList.length > 0 ? recordsList.map((record) => {
          return (
            <RecordItem
              keycloak={keycloak}
              key={record.id}
              conferenceId={record.conference_id}
              recordId={record.record_id}
              roomName={record.conference_name}
              fileName={record.file_name}
              recordFileSize={record.file_size.reference}
              startRecordTime={record.create_date}
              stopRecordTime={record.stop_recording_date}
              isChecked={recordsChecked[record.record_id]}
              onChecked={setChecked}
              hideAction={isItemChecked}
              deleteAction={handleDeleteRecord}
              language={language}
            />
          );
        }) : null}
      </div>
      <Modal
        title={null}
        centered
        visible={showPopupConfirmDelete}
        onOk={() => console.log("ok")}
        onCancel={() => setShowPopupConfirmDelete(false)}
        closable={false}
        footer={false}
        width={400}
        className="record-delete-popup"
      >
        <Row type="flex" justify="center">
          <Col md={24} sm={24} xs={24} className="content">
            {
            popupDeleteType === 'confirm' ? <div>
              <div>
                <img alt="delete" src="/portal/img/record-delete.png" />
              </div>
              <div className="popup-title">{t('my_record.delete_title1')}</div>
              <div className="popup-title-bold">{deleteList.length}{numAndTextSpace}{deleteList.length === 1 ? t('my_record.delete_title2') : t('my_record.delete_title3')}</div>
              <div className="popup-detail">
                {t('my_record.delete_note1')}<br />
                {t('my_record.delete_note2')}
              </div>
              <div className="action-pad">
                <Button className="popup-delete-btn" onClick={() => deleteCheckedItem()}>{t('my_record.delete_confirm_btn')}</Button>
              </div>
              <div className="action-pad">
                <Button className="popup-cancel-btn" onClick={() => setShowPopupConfirmDelete(false)}>{t('my_record.delete_cancel_btn')}</Button>
              </div>
            </div> : <div className="delete-popup-error">
                <div className="delete-logo">
                  <img alt="delete" src="/portal/img/delete-red.png" />
                </div>
                <div className="popup-title">{t('my_record.delete_error_title')}</div>
                <div className="popup-detail">{t('my_record.delete_error_detail')}</div>
                <div className="action-pad">
                  <Button className="popup-delete-btn" onClick={() => setShowPopupConfirmDelete(false)}>{t('my_record.delete_error_close')}</Button>
                </div>
              </div>
            }
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default translate()(RecordDetail);
